<template lang="pug">
  div
    .tabBar
      .icon(
        v-for="(tab,index) in tabs" :key='tab.id'
        :class="{'active' : path === tab.path}"
        @click="selTab(tab)"
      )
        figure
          div.unread(v-if="index === 1 && (unreadMessageInner !== 0 ) && path != '/news'")
            if unreadMessageInner !== 0
              span {{ unreadMessageInner > 99 ? '99+' : unreadMessageInner }}
          div.unread(v-if="index === 1 && (unreadMessage !== 0)")
            if unreadMessage !== 0
              span {{ unreadMessage > 99 ? '99+' : unreadMessage }}
          //- i.fa(:class="tab.icon")
          img.tab-img(:src="tab.img_active" v-if="path === tab.path")
          img.tab-img(:src="tab.img" v-else)
          figcaption {{ tab.title }}
</template>

<script>
import { getRecord, getType, updateReadState } from '@/apis/fromBaseApi/site_message'
import { getContactListApi } from '@/apis/ask2Api/im'
import { mapActions } from 'vuex'
export default {
  // props: ['tabs'],
  props: {
    tabs: Array,
    unreadMessage: {
      type: Number,
      default: 0
    },
    unreadAds: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      channel: 2, // 渠道 1-滇医通微信小程序，2-滇医通官方号微信公众号，3-滇医通微信公众号，4-滇医通支付宝小程序
      unread_count_map: {},
      no_read_num: 0
    }
  },
  computed: {
    path() {
      return this.$store.state.route.path
    },
    unreadMessageInner() {
      let num = 0
      if (this.unread_count_map && typeof this.unread_count_map === 'object') {
        for (let key in this.unread_count_map) {
          num += this.unread_count_map[key]
        }
      }
      if (this.no_read_num && this.no_read_num > 0) {
        num += this.no_read_num
      }
      return num || 0
    }
  },
  created() {
    let _this = this
    if (this.path != '/news') {
      if (localStorage.getItem('is_wx') == 1 || this.$noNeedLead) {
        // 小程序
        this.channel = 1
      } else if (localStorage.getItem('is_wx') === 0) {
        // H5
        if (localStorage.getItem('channel') == 2) {
          this.channel = 2
        } else if (localStorage.getItem('channel') == 1) {
          this.channel = 3
        }
      } else if (this.$isMy) {
        this.channel = 4
      }
      let data = localStorage.getItem('authtoken')
      if (data) {
        this.getRecord()
      }
    }
    Promise.all([this.getRecord(), this.get_list(), this.getType()]).finally(() => {
      if(this.$route.query.tabIndex){
        _this.changeActiveTypeId(-1)
      }
      this.setLoading(false)
    })
  },
  methods: {
    ...mapActions(['setLoading']),
    selTab(tab) {
      if (this.$route.path === tab.path) return
      this.$router.push(tab.path)
    },
  getType() {
      return new Promise((resolve, reject) => {
        getType({
          channel: this.channel
        })
          .then((res) => {
            this.typeList = res.data.list || []
            this.firstBtnLoading = true
            resolve()
          })
          .catch(() => {
            this.firstBtnLoading = true
            reject()
          })
      })
    },
    // 获取消息列表
    getRecord() {
      return new Promise((resolve, reject) => {
        let p = {
          channel: this.channel
        }
        if (this.activeTypeId === 0) {
          p.is_recommend = this.activeTypeId === 0
        } else {
          p.type_id = this.activeTypeId
        }
        getRecord(p)
          .then((res) => {
            this.record_list = res.data.record_list || []
            this.unread_count_map = res.data.unread_count_map || {}
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },
    // 获取消息列表（在线问诊）
    get_list() {
      let _this  = this
      return new Promise((resolve, reject) => {
        try {
          // 支付宝环境不展示在线问诊
          if (this.channel == 4) {
            resolve()
          }
          getContactListApi({
            doctorId: this.$store.getters.getDoctorId,
            patientId: this.$store.getters.getPatientId,
            isGroupByDoctorAndPatient: true
          })
            .then((res) => {
              if (res && res.status == 200) {
                this.ask_list = res.data

                this.no_read_num = 0
                res.data.forEach(element => {
                  this.no_read_num += element.unreadCount
                });
              } else {
                console.error('获取联系人列表失败:', res)
                this.ask_list = []
              }
              resolve()
            })
            .catch((error) => {
              console.error('获取联系人列表出错:', error)
              this.ask_list = []
              reject()
            })
          // this.newDytApiBaseApi
          //   .get('/ask/v3/user/manage-relations/list')
          //   .then((res) => {
          //     this.ask_list = res.data.data || []
          //     if (res.data && res.data.data && res.data.data[0]) {
          //       this.no_read_num = res.data.data[0].no_read_num
          //     }
          //     resolve()
          //   })
          //   .catch(() => {
          //     reject()
          //   })
        } catch (error) {
          reject()
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
@import '../styles/base.less';
.tabBar {
  background-color: #fff;
  border-top: 1px solid @bd_color;
  height: 1.3rem;
  padding: 0rem 0;
  display: flex;
  justify-content: space-around;
  text-align: center;
  color: @sub_color;
  .icon {
    width: 100%;
  }
  .icon.active {
    color: @main_color;
  }
  figure {
    position: relative;
  }
  .tab-img {
    width: 0.54rem;
    height: 0.54rem;
    margin-top: 0.19rem;
  }
  figcaption {
    margin-top: -0.2em;
  }
  .fa {
    font-size: 0.8rem;
  }
  .unread {
    position: absolute;
    top: 5%;
    left: 60%;
    // width: 0.64rem;
    min-width: 0.32rem;
    padding: 0 0.05rem;
    height: 0.32rem;
    background: #ff5959;
    border-radius: 0.16rem;
    color: #ffffff;
    font-size: 0.27rem;
    text-align: center;
  }
}
</style>
